import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";

const Education = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Education</h6>
          <hr />
          <h1 className="banner-title">
            Empower the Education Sector with <br /> Data-Driven Insights and
            Solutions
          </h1>

          <p>
            Leverage analytics and software solutions to enhance learning
            outcomes, optimize resources, and improve student engagement.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/young-people-studying-street_23-2147860553.jpg"
          alt="Education Analytics Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Education</h6>
              <h2 className="text-center">
                Transform Education with Data-Driven Insights and Software
                Solutions
              </h2>
              <p className="text-center">
                In the ever-evolving education sector, our software solutions
                and analytics services help educational institutions enhance
                teaching, streamline administrative processes, and improve
                student performance. From personalized learning platforms to
                data-driven dashboards, we offer tailored solutions to meet the
                needs of educators, students, and administrators.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Our Solutions</h2>
              <p className="text-center mb-0">
                Our custom software solutions are designed to help educational
                institutions leverage technology for enhanced teaching, better
                learning experiences, and improved student engagement.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Learning Management System (LMS)</a>
              </h3>
              <p className="mb-4">
                Our LMS software allows schools and universities to manage and
                track students' learning progress, assignments, and assessments.
                It provides a centralized platform for educators to communicate
                with students, create interactive lessons, and track academic
                progress.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Data-Driven Dashboards</a>
              </h3>
              <p className="mb-4">
                Our custom dashboards help educational institutions visualize
                key metrics like student performance, teacher efficiency, and
                administrative workflows. These real-time insights help
                institutions make data-driven decisions to enhance learning
                outcomes and operational efficiency.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">School Management System (SMS)</a>
              </h3>
              <p className="mb-4">
                Our SMS software streamlines school administration by managing
                student records, attendance, grades, and more. It helps
                educational institutions run efficiently and effectively with
                real-time reporting and data-driven insights.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Predictive Analytics for Enrollment</a>
              </h3>
              <p className="mb-4">
                Our predictive analytics solution helps educational institutions
                forecast enrollment trends, optimize course offerings, and plan
                resources effectively based on historical data and predictive
                models.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Virtual Classroom Solutions</a>
              </h3>
              <p className="mb-4">
                Our virtual classroom software facilitates online learning,
                enabling teachers to conduct live lectures, share resources, and
                interact with students in a digital environment. It supports
                video conferencing, assignment submissions, and more.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Student Feedback and Survey System</a>
              </h3>
              <p className="mb-4">
                Our feedback system allows educational institutions to gather
                real-time feedback from students and faculty, assess learning
                experiences, and improve curriculum and teaching methods.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section id="serv_h" className="p_3 mt-5">
        <div className="container" style={{ padding: 40 }}>
          <div className="row serv_h1 mb-4 text-center">
            <div className="col-md-12">
              <div className="serv_h1l">
                <h3>Our Clients</h3>
                {/* <p className="mb-0">Trusted by leading innovators worldwide.</p> */}
              </div>
            </div>
          </div>

          <div className="my-swiper-container">
            <Swiper
              modules={[]}
              spaceBetween={30} // Adjust space between slides
              slidesPerView={3} // Show exactly 3 slides
              loop={true} // Enable infinite looping
              centeredSlides={false} // No centering needed if all 3 are visible
              style={{
                width: "100%", // Make the Swiper full-width
              }}
            >
              {/* Slide 1 */}
              <SwiperSlide>
                <img
                  src="./assets/img/logo.png"
                  alt="React.js"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* Slide 2 */}
              <SwiperSlide>
                <img
                  src="https://www.hospinetics.com/static/img/logo.svg"
                  alt="upay"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* Slide 3 */}
              <SwiperSlide>
                <img
                  src="https://edubriqglobal.com/static/media/Logo.394d2e8831219f98fac2.png"
                  alt="Client Logo 4"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>
            </Swiper>

            <div className="my-swiper-button-prev"></div>
            <div className="my-swiper-button-next"></div>
          </div>
        </div>
      </section>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">
                  Ready to Transform Education with Software Solutions?
                </h2>
                <p className="mt-3">
                  Our innovative education software solutions are designed to
                  help you improve learning outcomes, streamline administration,
                  and enhance the overall educational experience.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Education Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Education;
